import { isWithinInterval, parseISO } from 'date-fns'
import { type IDateRange2 } from '@floriday/floriday-ui'
import { type KlantTransactie, TransactieType } from '../types/api'
import { normalizeTransactionType } from './transactionTypeMapper'

export const transactionFilterTypeOptions: TransactieType[] = [
  TransactieType.UitgifteDock,
  TransactieType.UitgifteMobiel,
  TransactieType.UitgifteVast,
  TransactieType.InnameVast,
  TransactieType.InnameMobiel,
]

export const applyTransactionFilters = (
  transactions: KlantTransactie[],
  filters: {
    searchQuery: string
    selectedTransactionTypes: TransactieType[]
    dateFilter: IDateRange2 | null
    selectedBusinessAssociationIds: number[]
  }
): KlantTransactie[] => {
  const {
    searchQuery,
    selectedTransactionTypes,
    dateFilter,
    selectedBusinessAssociationIds,
  } = filters
  const normalizedSearchQuery = searchQuery.trim().toLowerCase()

  return transactions.filter(transaction => {
    if (
      normalizedSearchQuery &&
      !transaction.id?.toLowerCase().includes(normalizedSearchQuery)
    ) {
      return false
    }

    if (
      selectedTransactionTypes.length > 0 &&
      !selectedTransactionTypes.some(
        transactionType =>
          normalizeTransactionType(transactionType) ===
          normalizeTransactionType(transaction.transactieType)
      )
    ) {
      return false
    }

    if (dateFilter) {
      const transactionDate = parseISO(transaction.datum)
      if (
        !isWithinInterval(transactionDate, {
          start: dateFilter.from,
          end: dateFilter.to,
        })
      ) {
        return false
      }
    }

    if (
      selectedBusinessAssociationIds.length > 0 &&
      (transaction.opdrachtgever === null ||
        !selectedBusinessAssociationIds.includes(transaction.opdrachtgever))
    ) {
      return false
    }

    return true
  })
}
